<template>
    <v-container>
        <v-layout column class="card">
            <v-label><h4>Configuração do mês comercial</h4></v-label>
            <v-layout wrap mt-5>
                <v-flex xs12 sm6 md4 lg3 xl2 v-for="(mes,i) in meses" :key="i">
                    <v-layout class="box_mes" column>
                        <div class="mes_head primary">{{nomeMes(mes.date, i)}}</div>
                        <v-layout pl-3 pr-3 pb-4 pt-1 column>
                            <date-field label="Início"
                                        v-model="mes.inicio"
                                        :start="mes.date"
                                        :min="mes.date"
                                        :max="max(mes.date)"
                                        @invalid-date="invalidDate"
                                        @invalid-range="invalidRange"></date-field>
                        </v-layout>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout column mt-3>
                <v-flex>
                    * O início dos meses comerciais não informados serão salvos por padrão como o primeiro dia do mês.
                </v-flex>
            </v-layout>
            <v-layout mt-3>
                <v-flex xs12 sm4 lg3 xl2>
                    <v-btn class="btn-default primary" @click="salvar">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>

import DateField from '../components/DateField'
import { alert, error } from '../plugins/helpers'
import moment from 'moment'

export default {
  components: { DateField },
  data: () => ({
    meses: Array.apply(null, { length: 13 }).map((n, i) => ({ date: moment().add(i - 1, 'month').startOf('month').format('YYYY-MM-DD'), inicio: '' }))
  }),
  methods: {
    max (date) {
      return moment(date).endOf('month').format('YYYY-MM-DD')
    },
    invalidDate (date) {
      const data = moment(date)
      alert('Data ' + (data.isValid() ? ' ' + data.format('DD/MM/YYYY') : '') + ' inválida')
    },
    invalidRange (date) {
      alert('Data ' + moment(date).format('DD/MM/YYYY') + ' fora do intervalo do mês')
    },
    nomeMes (date, i) {
      if (i === 0) {
        return 'Mês anterior'
      } else if (i === 1) {
        return 'Mês atual'
      } else {
        return moment(date).format('MMMM / YYYY')
      }
    },
    salvar () {
      this.$http.post('/admin/configuracoes/mescomercial', {
        meses: this.meses
      }).then(() => {
        alert('Configuração do mês comercial salva com sucesso!')
        this.meses.filter(mes => !mes.inicio).forEach(mes => (mes.inicio = mes.date))
      }).catch(err => {
        error(err, 'Não foi possível salvar as informações.')
      })
    }
  },
  mounted () {
    this.$http.get('/admin/configuracoes/mescomercial').then(res => {
      this.meses = res.data.meses
    }).catch(err => {
      error(err, 'Não foi possível recuperar as informações.')
    })
  }
}
</script>

<style>
.datePicker .v-date-picker-header .v-btn--disabled {
    visibility: hidden;
}
</style>

<style scoped>
.box_mes {
    border: solid 1px #ccc;
    border-radius: 10px;
    margin: 10px;
}

.mes_head {
    border-radius: 50px;
    color: white;
    position: relative;
    top: -10px;
    font-weight: bold;
    width: 140px;
    text-align: center;
    margin: 0 auto;
    text-transform: capitalize;
}

.mes_head span {
    display: block;
    margin: 0 auto;
}
</style>
